"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateMediaVisualizationBatchDto = exports.CreateMediaVisualizationDto = void 0;
class CreateMediaVisualizationDto {
    displayId;
    mediaCampaignId;
    proofId;
    instanceId;
    occurrenceId;
    playerProtocolVersion;
    date;
    visualizations;
    clicks;
    impressions;
}
exports.CreateMediaVisualizationDto = CreateMediaVisualizationDto;
class CreateMediaVisualizationBatchDto {
    items;
}
exports.CreateMediaVisualizationBatchDto = CreateMediaVisualizationBatchDto;
